import React from 'react';
import PropTypes from 'prop-types';
import { FileDownload } from '../../prop-types';
import { mimeTypeToString } from '../../utils/content-formatting';
import iconSrc from '../../utils/iconSrc';
// Styles
import { DownloadLink, DownloadSVG } from './styles';

const DownloadCTA = ({ buttonText, download, className, buttonType }) => (
  <DownloadLink
    $bg={buttonType || 'primary'}
    className={`${className || ''} tracking-download`}
    link={{ ...download }}
    dataTracking={mimeTypeToString(download.file.contentType)}
    download
  >
    <DownloadSVG src={iconSrc('download')} cacheRequests />
    <div>
      <div>{buttonText}</div>
    </div>
  </DownloadLink>
);

DownloadCTA.propTypes = {
  buttonText: PropTypes.string.isRequired,
  download: PropTypes.shape({
    file: FileDownload,
  }).isRequired,
  className: PropTypes.string,
  buttonType: PropTypes.string,
};

export default DownloadCTA;
